import React from 'react';
import { DetailLayout } from '../../components/DetailLayout';
import { translate } from '../../i18n';

interface NotFoundProps {}

const NotFound: React.FC<NotFoundProps> = () => {
  return <DetailLayout title="404.title">{translate('404.description')}</DetailLayout>;
};

export default NotFound;
